export default class ErrorService {
    report(error){
        alert(`Error Code: ${error.code}\n\n${error.message}`)
    }
}